module.exports = __webpack_public_path__ + "img/file-2.9230b8b7.svg";